<template>
    <div class="dashboard-wrapper pb-1 mb-3 w-100">
        <div class="pt-2 pb-2">
            <i class="fa fa-bar-chart dark-blue" aria-hidden="true"></i>
            <span class="dark-blue font-weight-bold ml-1"> {{ $t('results') }} </span>
            <i
                v-b-tooltip.hover
                class="fa fa-question-circle icon-help ml-1"
                aria-hidden="true"
                :title="$t('statusInfoMessage')"
            ></i>
        </div>
        <b-row class="mb-2">
            <b-col class="col">
                <div class="border-div border-objectives">
                    <b-form-checkbox
                        id="show-initiative-objectives"
                        v-model="selected"
                        value="objectives"
                        name="show-initiative-objectives"
                    >
                        {{ $t('objectives.objectives') }}
                    </b-form-checkbox>
                    <span class="font-weight-bold"> {{ objectivesCount }} ({{ objectiveResultsPercentage }}%) </span>
                </div>
            </b-col>
            <b-col class="col">
                <div class="border-div border-key-results">
                    <b-form-checkbox
                        id="show-initiative-key-results"
                        v-model="selected"
                        value="key-results"
                        name="show-initiative-key-results"
                    >
                        {{ $t('insights.keyResults') }}
                    </b-form-checkbox>
                    <span class="font-weight-bold"> {{ keyResultsCount }} ({{ keyResultsPercentage }}%) </span>
                </div>
            </b-col>
            <b-col v-if="hasDaily" class="col">
                <div class="border-div border-initiatives">
                    <b-form-checkbox
                        id="show-initiative-initiatives"
                        v-model="selected"
                        value="initiatives"
                        name="show-initiative-initiatives"
                    >
                        {{ $t('daily.initiatives') }}
                    </b-form-checkbox>
                    <span class="font-weight-bold">
                        {{ initiativesCount }}
                    </span>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { includes } from 'lodash'

export default {
    props: {
        filters: {
            type: Object,
        },
        allOkrs: {
            type: Boolean,
        },
    },
    data() {
        return {
            selected: ['objectives', 'key-results', 'initiatives'],
        }
    },
    computed: {
        ...mapGetters(['getOkrsDashData', 'getAllOkrsDashData']),
        dashData() {
            return this.allOkrs ? this.getAllOkrsDashData : this.getOkrsDashData
        },
        hasDaily() {
            return includes(this.$store.state.profile.user.has_modules, 'has_daily')
        },
        objectivesCount() {
            return this.dashData.objectives_count
        },
        keyResultsCount() {
            return this.dashData.key_results_count
        },
        initiativesCount() {
            return this.dashData.initiatives_count
        },
        keyResultsPercentage() {
            return this.calculateProgressPercentage(this.dashData, 'key_results_count', 'key_results_progress')
        },
        objectiveResultsPercentage() {
            return this.calculateProgressPercentage(this.dashData, 'objectives_count', 'objectives_progress')
        },
    },
    watch: {
        selected() {
            this.$emit('selected', this.selected)
        },
    },
    mounted() {
        this.$emit('selected', this.selected)
    },
    methods: {
        calculateProgressPercentage(object, count, progress) {
            return object[progress] ? Math.round(((object[progress] / object[count]) * 100).toFixed(2)) : 0
        },
    },
    i18n: {
        messages: {
            'en-US': {
                label: 'Key results',
                statusInfoMessage:
                    "Values ​​below are a simple average of the contributor's OKRs, and those to which they contribute",
                results: 'Results',
            },
            'es-ES': {
                label: 'Resultados clave',
                statusInfoMessage:
                    'Los valores a continuación son un promedio simple de los OKR del contribuyente y aquellos a los que contribuye',
                results: 'Resultados',
            },
            'pt-BR': {
                label: 'Resultados chave',
                statusInfoMessage:
                    'Valores abaixo são uma média simples dos OKRs do colaborador, e daqueles para os quais ele contribui',
                results: 'Resultados',
            },
        },
    },
}
</script>

<style scoped>
.dashboard-wrapper {
    font-size: 0.9rem !important;
    white-space: nowrap;
}

.border-div {
    height: 50px !important;
    padding-left: 0.5rem !important;
    border-left: 4px solid;
}
.border-objectives {
    border-color: #022b4f !important;
}
.border-key-results {
    border-color: #009ada !important;
}
.border-initiatives {
    border-color: #ccebf8 !important;
}

.dashboard-wrapper {
    max-width: 45vw;
    font-size: 1.1em;
}

@media screen and (max-width: 1440px) {
    .dashboard-wrapper {
        max-width: 55vw;
        font-size: 0.8rem !important;
    }
}
.icon-help {
    color: #bec0c0;
}
</style>
